import { render, staticRenderFns } from "./AccessNoticePage.vue?vue&type=template&id=bb28ee12&scoped=true&"
import script from "./AccessNoticePage.vue?vue&type=script&lang=js&"
export * from "./AccessNoticePage.vue?vue&type=script&lang=js&"
import style0 from "./AccessNoticePage.vue?vue&type=style&index=0&id=bb28ee12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb28ee12",
  null
  
)

export default component.exports